import { addDoc } from 'firebase/firestore';
import { studentSubCol } from '../firebase/config';
import { formatDateTR, getDayFromDate } from '../utils/dateUtils';
import { generateId } from '../utils/stringUtils';

export function buildProgramPayload({ dateISO, warmup, main, cooldown }) {
  return {
    id: generateId(),
    day: getDayFromDate(dateISO),
    date: formatDateTR(dateISO),
    dateISO,
    warmup,
    main,
    cooldown,
    completed: false,
    archived: false,
  };
}

export async function addProgram(studentId, payload) {
  await addDoc(studentSubCol(studentId, 'programs'), payload);
}
